module.exports = __webpack_public_path__ + "static/media/Jaime Lannister 3.c940565c.jpg";